import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloseCircleDashed: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCloseCircleDashed"><Path d="M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round" strokeDasharray="4 4"/><Path d="M15 9L9 15" stroke="currentColor" strokeLinecap="square"/><Path d="M15 15L9 9" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCloseCircleDashed;
